import { useMap } from '@vis.gl/react-google-maps';
import { useEffect, useState } from 'react';

export const highDetailMinZoom = 9;

export function useZoom() {
  const map = useMap();
  const [zoom, setZoom] = useState(map?.getZoom() ?? 0);

  useEffect(() => {
    if (!map) return;

    const listener = map.addListener('zoom_changed', () => {
      const zoom = map.getZoom();
      if (zoom) {
        setZoom(zoom);
      }
    });

    return () => listener.remove();
  }, [map]);

  return zoom;
}
